import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

function DialogAlertVerifikasi({ open, handleClose, verifikasiData, profil }) {
  const history = useHistory();
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography style={{ fontSize: "15px" }}>Konfirmasi!</Typography>
      </DialogTitle>
      {verifikasiData === undefined && (
        <DialogContent>
          <Typography style={{ fontSize: "14px" }}>
            👋 Hallo Seller Tangguh, yuk segera verifikasi akun untuk
            memvalidasi data dan memudahkanmu melakukan transaksi.
          </Typography>
        </DialogContent>
      )}
      {verifikasiData?.isRejected === true && (
        <DialogContent>
          <Typography style={{ fontSize: "14px" }}>
            👋 Hallo {profil?.nama}, verifikasi akun mu gagal nih, yuk
            verifikasi kembali dalam melakukan transaksi 👋
          </Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button color="secondary" onClick={handleClose} size="small">
          Nanti
        </Button>
        <Button
          color="primary"
          onClick={() => history.push("/akun/verifikasi")}
          size="small"
        >
          Lanjutkan
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogAlertVerifikasi;
